export const getModelEmpresa = () => ({
    iIdEmpresa: 0,
});

export const getFormEmpresa = () => ({
    txtFolioEmpresa: {
        label: "Folio de empresa:",
        required: false,
        value: "",
        error: false,
        message: "El folio de empresa es requerido",
    },
    txtNombreEmpresa: {
        label: "Nombre de empresa:",
        required: true,
        value: "",
        error: false,
        message: "El nombre de empresa es requerido",
    },
    txtCorreoEmpresa: {
        label: "Correo electrónico de empresa:",
        required: true,
        value: "",
        error: false,
        message: "Ingrese un correo válido",
    },
});

export const getFormFiltroFolios = () => ({
    txtOrigen: {
        label: "Origen de folio:",
        value: "",
    },
    txtProducto: {
        label: "Producto Meditoc:",
        value: "",
    },
    txtVigente: {
        label: "Folio vigente:",
        value: "",
    },
});

export const getFormVigencia = () => ({
    dtpFechaVigencia: {
        label: "Nueva fecha de vigencia:",
        required: true,
        value: null,
        error: false,
        message: "Seleccione la fecha de vencimiento",
    },
});

export const getFormCargarArchivo = () => ({
    txtProducto: {
        label: "Producto Meditoc:",
        required: true,
        value: "",
        error: false,
        message: "Seleccione el producto",
    },
    txtArchivoFolios: {
        label: "Nombre de archivo:",
        required: true,
        value: "",
        error: false,
        message: "No se ha cargado ningún archivo",
    },
});

export const getEmpresaColumns = () => [
    { title: "Folio", field: "sFolioEmpresa" },
    { title: "Nombre", field: "sNombre" },
    { title: "Correo", field: "sCorreo" },
    { title: "Fecha", field: "sFechaCreacion" },
];

export const getAdministrarEmpresaColumns = () => [
    { title: "", field: "sStatus", hideFilter: true, hideSort: true },
    { title: "Folio", field: "sFolio" },
    { title: "Producto", field: "sNombreProducto" },
    { title: "Origen", field: "sOrigen" },
    { title: "Creado", field: "sFechaCreacion" },
    { title: "Vencimiento", field: "sFechaVencimiento" },
];

export const getAgregarFolioColumns = () => [
    { title: "ID", field: "iIdProducto" },
    { title: "", field: "sIconStatus", hideFilter: true, hideSort: true },
    { title: "Nombre", field: "sNombre" },
    { title: "Cantidad", field: "iCantidad", edit: true, type: "uint" },
    { title: "Precio unitario", field: "sCosto" },
];

export const getDetalleArchivoColumns = () => [
    { title: "Folio", field: "sFolio" },
    { title: "Contraseña", field: "sPassword" },
];

export const getEliminarFoliosColumns = () => [
    { title: "Folio", field: "sFolio" },
    { title: "Tipo", field: "sTipoProducto" },
    { title: "Producto", field: "sNombreProducto" },
];

export const getResumenFoliosColumns = () => [
    { title: "", field: "sIconStatus" },
    { title: "Descripción", field: "sNombre" },
    { title: "Cantidad", field: "iCantidad" },
    { title: "Precio unitario", field: "sCosto" },
    { title: "Subtotal", field: "sSubtotal" },
];
